module.exports = __webpack_public_path__ + "static/media/patternCapture.8f307798.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/patternCapture.gif
// module id = 192
// module chunks = 0